import BelozIcon from '../atoms/beloz.icon';


const NavBar = () => {
    const navBarStyle = {
        display: 'flex',
        alignItems: 'center',
    };

    return (
        <nav style={navBarStyle}>
            <BelozIcon/>
        </nav>
    );
};

export default NavBar;